angular.module('mtic')
.service('apiTranslationService', function ($log, $http, API_CONFIG, language, $timeout, $q) {

    var apiTranslationService = {};
    var translations_map = {};
    var retrieved_packs = [];

    apiTranslationService.getTranslationPack = function(pack_id){
      return $q(function(resolve, reject){
        if(retrieved_packs.indexOf(pack_id) > -1){
          resolve(translations_map);
        }
        var tran_packs = [pack_id];
        var tran_packs_safe = encodeURIComponent(JSON.stringify(tran_packs));
        $http.get('https://stats.vretta.com/pdf-maker/translation-packs?packIds='+tran_packs_safe+'&apiUrl='+encodeURIComponent(API_CONFIG.REMOTE_API))
        .then(function(data){
          var translations = data.data;
          retrieved_packs.push(pack_id);
          _.map(translations, function(pack_id, id_key){
            if(pack_id.elements){
              _.map(pack_id.elements, function(val, element_key){
                let content = typeof val === 'string' ? JSON.parse(val) : val;
                translations_map[element_key] = content.text;//TRANPACK_PREFIX+id_key+'/'+
              })
            }
          })
          $log.log('retrieved translations : ', translations_map)
          resolve(translations_map)
        })
        .catch(function(err){
          reject('error')
        })
      })      
    }

    apiTranslationService.getTranslation = function(trans_id){
      if(translations_map[trans_id]){
        return translations_map[trans_id][language.getCurrentSelectedLanguage()].val
      }
      return trans_id
    }


    return apiTranslationService;

});

